import ClassNames from "classnames";
import { FunctionComponent, HTMLAttributes } from "react";
import { Link, LinkProps as RouterLinkProps } from "react-router-dom";
import styles from "../stylesheets/components/editor-ui-control.module.css";

interface SharedProps {
  active?: boolean;
}

type ButtonProps = {
  type: "button";
  disabled?: boolean;
} & HTMLAttributes<HTMLButtonElement>;
type LinkProps = { type: "link" } & RouterLinkProps;
type LabelProps = { type: "label" } & HTMLAttributes<HTMLLabelElement>;
type Props =
  | (ButtonProps & SharedProps)
  | (LinkProps & SharedProps)
  | (LabelProps & SharedProps);

const EditorUIControl: FunctionComponent<Props> = ({
  active,
  className,
  ...props
}) => {
  const cls = ClassNames(
    "Btn",
    styles.EditorUIControl,
    { "Btn--active": active },
    className,
  );

  return (
    <li>
      {props.type === "button" && <ButtonBtn className={cls} {...props} />}
      {props.type === "link" && <LinkBtn className={cls} {...props} />}
      {props.type === "label" && <LabelBtn className={cls} {...props} />}
    </li>
  );
};

const ButtonBtn = ({ type: _type, children, ...props }: ButtonProps) => {
  return (
    <button type="button" {...props}>
      {children}
    </button>
  );
};

const LinkBtn = ({ type: _type, children, ...props }: LinkProps) => {
  return <Link {...props}>{children}</Link>;
};

const LabelBtn = ({ type: _type, children, ...props }: LabelProps) => {
  return <label {...props}>{children}</label>;
};

export default EditorUIControl;
